import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ECCOLogo } from "@ecco/ui/ecco-logo";
import { NextLink } from "@components/ui/next-link/NextLink";
import { sizes } from "@ecco/ui/tokens";

export const Logo = () => {
    const { get: getMicrocopy } = useMicrocopy();
    return (
        <NextLink
            href="/"
            aria-label={getMicrocopy(CommonCMS.shared, CommonCMS.ariaLabels.homeButtonAria)}
            data-testid="homelink"
            display="flex"
            alignItems={"center"}
            minW="eccoLogo"
            h={"inherit"}
            _hover={{ color: "gray.500" }}
        >
            <ECCOLogo h={{ base: "18px", md: sizes.icon.md }} />
        </NextLink>
    );
};
